import React from 'react';
import '../../styles/Body.css';

type BodyProps = {
  children: React.ReactNode;
  sidebarWidth?: string;
  style?: React.CSSProperties;
};

const Body: React.FC<BodyProps> = ({
  children,
  sidebarWidth = '260px',
  style = {},
}) => {
  const inlineStyle: React.CSSProperties = {
    marginLeft: sidebarWidth,
    padding: '0px',
    boxSizing: 'border-box',
    width: `calc(100% - ${sidebarWidth})`,
    ...style,
  };

  return <div className="page-body" style={inlineStyle}>{children}</div>;
};

export default Body;
